import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import SelectConstant from 'FDComponents/constants/Select';
import SelectSeason from 'FDComponents/seasons/Select';

const styles = theme => ({
  body: {
    borderLeft: `3px solid ${theme.palette.primary[500]}`,
  },
});

@withStyles(styles)
@reduxForm({
  form: 'shirt_form',
  validate: values => {
    const errors = {};
    if (!values.season) {
      errors.season = 'error_required';
    }
    return errors;
  },
})
@injectIntl
export default class ShirtDialog extends Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
    this.props.reset();
  };
  handleConfirm = article => {
    this.handleClose();
    this.props.onCreate(article);
  };

  render() {
    const {
      title,
      handleSubmit,
      pristine,
      submitting,
      classes,
      children,
      intl: { messages: m },
      disabled,
      valid,
    } = this.props;
    const { open } = this.state;

    return (
      <div>
        {React.cloneElement(children, { onClick: this.handleOpen, disabled })}
        <Dialog open={open} classes={{ paper: classes.body }}>
          <DialogTitle>{title}</DialogTitle>
          <form onSubmit={handleSubmit(this.handleConfirm)}>
            <DialogContent>
              <Field name="type" component={SelectConstant} entity="product" autoFocus />
              <Field name="season" component={SelectSeason} />
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.handleClose} disabled={submitting}>
                {m.button_cancel}
              </Button>
              <Button
                color="primary"
                variant="contained"
                type="submit"
                disabled={!valid || pristine || submitting}
              >
                {m.button_create}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}
